import { fetchApi } from '../config/api';

export interface AccountDeletionStatus {
  requested: boolean;
  requestedAt: string | null;
  scheduledAt: string | null;
  graceDays: number;
  /** z.B. "ownsStationWithMembers" */
  blockers: string[];
  isAdmin: boolean;
  hasPassword: boolean;
}

const unwrap = (res: any): AccountDeletionStatus => res?.data ?? res;

/** Sagt dem Banner im App-Layout, dass sich der Antrag geändert hat (Card und Banner teilen keinen State). */
export const DELETION_CHANGED_EVENT = 'account-deletion-changed';
const announce = (status: AccountDeletionStatus) => {
  window.dispatchEvent(new CustomEvent<AccountDeletionStatus>(DELETION_CHANGED_EVENT, { detail: status }));
  return status;
};

export const getDeletionStatus = async () => unwrap(await fetchApi('/account/deletion'));

export const requestDeletion = async (password: string) =>
  announce(unwrap(await fetchApi('/account/deletion', { method: 'POST', body: JSON.stringify({ password }) })));

export const cancelDeletion = async () => announce(unwrap(await fetchApi('/account/deletion', { method: 'DELETE' })));
